// Mock data for Well Cargo clone

export const stats = [
  {
    id: 1,
    value: "24Mil",
    label: "PELO MAR",
    icon: "ship"
  },
  {
    id: 2,
    value: "24t",
    label: "PELO AR",
    icon: "plane"
  },
  {
    id: 3,
    value: "+95",
    label: "PAÍSES",
    icon: "globe"
  }
];

export const mainServices = [
  {
    id: 1,
    title: "Transporte Aéreo",
    icon: "plane",
    description: "Somos parceiros das principais companhias aéreas do mercado, oferecendo soluções ágeis e seguras para importações e exportações com embarques para os principais aeroportos internacionais do mundo. Além do transporte, contamos com uma estrutura logística completa, incluindo serviços de consolidação de cargas e armazenamento em warehouses parceiras estrategicamente localizadas, garantindo maior eficiência, controle e otimização de custos. Seja para cargas urgentes, sensíveis, de alto valor, perigosas, perecíveis ou com controle de temperatura, nossa equipe atua com precisão e acompanhamento próximo, proporcionando uma operação aérea com fluidez e total previsibilidade."
  },
  {
    id: 2,
    title: "Transporte Marítimo",
    icon: "ship",
    description: "Possuímos parceria com os principais armadores e agentes internacionais, oferecendo soluções completas e personalizadas para o transporte marítimo de importação e exportação. Nosso know-how aliado a uma rede global qualificada nos permite atender com excelência os mais diversos tipos de operação, garantindo segurança, previsibilidade e suporte dedicado em todas as etapas do processo. Estamos preparados para atuar com diferentes modalidades de transporte de carga, incluindo: LCL (carga consolidada), FCL (full contêiner), Break Bulk, Cargas Projeto, Cargas Ro-Ro (Roll-on/Roll-off). Com a Well Cargo, sua carga marítima navega com eficiência e confiança, de ponta a ponta."
  },
  {
    id: 3,
    title: "Transporte Rodoviário",
    icon: "truck",
    description: "Oferecemos soluções rodoviárias com agilidade, segurança e alto padrão de qualidade, conectando portos, aeroportos, armazéns e plantas industriais em todo o território nacional e internacional. Atuamos com uma ampla gama de serviços terrestres, incluindo: Transporte de contêineres, Cargas consolidadas (LTL), Cargas perigosas, Cargas projeto, Cargas em regime de DTA e MIC-DTA. Com uma rede de transportadoras parceiras e rígido controle operacional, atuamos para assegurar o cumprimento de prazos, a rastreabilidade e o suporte dedicado em cada etapa da movimentação. Conte com a Well Cargo para um transporte terrestre eficiente, confiável e alinhado às exigências do comércio exterior."
  }
];

export const otherServices = [
  {
    id: 1,
    title: "Warehousing",
    description: "Nossos serviços vão além do transporte. Contamos com uma rede global de warehouses parceiros, estrategicamente posicionados para oferecer soluções completas de armazenagem e logística integrada. Oferecemos suporte nas principais etapas logísticas, incluindo: Armazenagem temporária ou de longo prazo, Etiquetagem e repacking, Pesagem e inspeção, Consolidação e desconsolidação de cargas, Estufagem e desova de contêineres."
  },
  {
    id: 2,
    title: "Seguro Internacional",
    description: "A segurança da sua carga é prioridade. Por isso, oferecemos seguros internacionais com cobertura ampla e personalizada, garantindo tranquilidade durante todo o trajeto, seja por via aérea, marítima ou terrestre. Nossos seguros abrangem diferentes tipos de mercadorias e operações, tanto de importação quanto exportação."
  },
  {
    id: 3,
    title: "Consultoria",
    description: "Está enfrentando dificuldades para entender os processos do comércio exterior de ponta a ponta? A Well Cargo oferece assessoria personalizada em logística internacional, atuando lado a lado com sua empresa para assegurar clareza, segurança e eficiência nas operações."
  },
  {
    id: 4,
    title: "Desembaraço Aduaneiro",
    description: "Possuímos uma estrutura especializada em regulamentações aduaneiras e processos alfandegários no Brasil e em diversos países, garantindo que suas operações ocorram com eficácia, conformidade e agilidade."
  }
];

export const navItems = [
  { id: 1, label: "Início", href: "/" },
  { id: 2, label: "Quem somos", href: "/sobre" },
  { id: 3, label: "Serviços", href: "/servicos" },
  { id: 4, label: "Contato", href: "/contato" },
  { id: 5, label: "Blog", href: "/blog" }
];

export const offices = [
  {
    id: 1,
    city: "Vila Velha/ES",
    type: "Matriz",
    address: "Rua Sete de Junho, 33, Sala 506, Coqueiral de Itaparica – CEP 29.102-310"
  },
  {
    id: 2,
    city: "Belo Horizonte/MG",
    type: "Filial",
    address: "Rua Tomé de Souza, 830, Sala 1602, Savassi – CEP 30.140-136"
  },
  {
    id: 3,
    city: "Itajaí/SC",
    type: "Filial",
    address: "Rua Samuel Heusi, nº 463, Sala 606, Centro – CEP 88.301-320"
  },
  {
    id: 4,
    city: "São Paulo/SP",
    type: "Filial",
    address: "Av. Paulista, 1439, Ed. Mario Wallace Simonsen, 1º andar, cj 12 – CEP 01.311-200"
  }
];

export const contactInfo = {
  phones: ["+55 27 99758-0648", "+55 27 3534-2660", "+55 27 99974-4514"],
  email: "sales@wellcargo.com.br"
};

export const aboutContent = {
  title: "Solução de Comércio Exterior para todos os Segmentos",
  paragraphs: [
    "A Well Cargo é uma empresa especializada em logística internacional que combina inteligência em comércio exterior com operações de alto desempenho. Atuamos como extensão da equipe dos nossos clientes, oferecendo soluções personalizadas e suporte consultivo em cada etapa do processo — do planejamento à entrega.",
    "Com mais de 15 anos de experiência no setor, nossa equipe alia domínio técnico, agilidade e proximidade no atendimento, proporcionando previsibilidade, segurança e eficiência operacional em todas as operações. Nossa atuação é nacional e internacional, com uma ampla rede de parceiros logísticos e presença em 196 países por meio da WCA World, a maior rede global de agentes de cargas.",
    "Nosso propósito é descomplicar o comércio exterior, tornando-o mais leve, acessível e seguro com a parceria certa. Acreditamos que um serviço logístico de excelência vai além da execução: envolve relacionamento, comprometimento e visão estratégica."
  ]
};
